export default __webpack_public_path__ + "static/media/pending payouts.4a483806.svg";